// tslint:disable: triple-equals
export const fetchMandarinModule = (id) => {
    const filterdata = mandarinData[0].modules.find(o => o.id == id);
    return {
    ...filterdata,
    module: filterdata.name,
    moduleId: filterdata.id,
    };
};

export const mandarinData: any = 
    [{
        id: 1,
        name: 'Mandarin Oriental Training Videos',
        modules: [
            {
                id: 1,
                label: 'EI Behavioral Standard Skills for Colleagues',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+01.2a+Emotional+Intelligence+Skills+for+Colleagues.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 2,
                label: 'EI Behavioral Standard Skills for Managers',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+01.2b+Emotional+Intelligence+Skills+for+Managers.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 3,
                label: 'We Understand that You are Unique',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+02.1+We+Understand+that+You+are+Unique.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 4,
                label: 'We Welcome You with Warmth',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+03.1+We+Welcome+You+with+Warmth.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 5,
                label: 'We Listen to Everything You Say',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+04.1+We+Listen+to+Everything+You+Say.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 6,
                label: 'We Anticipate What You Need Before You Ask',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+05.1+We+Anticipate+What+You+Need+Before+You+Ask.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 7,
                label: 'We Take Ownership',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+11.1+We+Take+Ownership.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 8,
                label: "We Never Say 'No'",
                videoUrl: "https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+07.1+We+Never+Say+'No'.mp4",
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 9,
                label: 'We Are Mindful of Our Oriental Heritage',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+08.1+We+Are+Mindful+of+Our+Oriental+Heritage.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 10,
                label: 'We Guide You If You Need Direction',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+09.1+We+Guide+You+If+You+Need+Direction.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 11,
                label: 'We Add Unexpected Joy to Your Day',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+06.1+We+Add+Unexpected+Joy+to+Your+Day.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 12,
                label: 'We Leave You with Lasting Memories',
                videoUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+12.1+We+Leave+You+with+Lasting+Memories.mp4',
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            },
            {
                id: 13,
                label: "We Recognise You If You're a Member of Fans of M.O.",
                videoUrl: "https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/1191+-+10.1+We+Recognise+You+If+You're+a+Member+of+Fans+of+M.O..mp4",
                pictureUrl: 'https://s3.amazonaws.com/com.lqa.v5.images.dev/training-videos/mandarin-training-videos/preview/Image.png',
                minScoreRequiredToPass: 0.8,
                questionExpiresIn: 25,
                responseExpiresIn: 30,
                videoLength: '00:00',
                bestScore: null,
            }, 
        ],
    }];
